import axiosClient from '@/shared/axios';
import { USER } from '@/shared/constants/endpoints';

export const LoginUser = (params) => axiosClient.post(USER.LOGIN, params);

export const GetUserData = (id) => {
  return axiosClient.get(USER.PROFILE.replace(':id', id));
};

export const ResetLink = (email) =>
  axiosClient.post(USER.RESET_PASSWORD, email);

export const ChangePassword = (params) =>
  axiosClient.post(USER.CHANGE_PASSWORD, params);

export const LogoutUser = () => {
  localStorage.removeItem('token');
  axiosClient.defaults.headers.Authorization = null;
};
